var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pt-life-experience-pavilion-form',{ref:"form",staticClass:"pt-hospital-form__withData",attrs:{"lifeExperienceHallsDetail":_vm.lifeExperienceHallsDetail,"isEdit":_vm.isEdit,"organizationList":_vm.organizationList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }